import * as React from "react";
import { Spinner } from "./externals";
import "./Loading.scss";
export function Loading({ minimal = false, size = 20, }) {
    const text = minimal ? undefined : "Loading...";
    return (React.createElement("div", { className: "loading-component", role: "loader" },
        React.createElement(Spinner, { size: size }),
        text ? React.createElement("span", { className: "loading-component_heading" }, text) : null));
}
//# sourceMappingURL=Loading.js.map